import React, {useState} from 'react';
import axios from 'axios';
import {ReactComponent as Spinner} from '../../assets/oval-black.svg';
import GoToSignUp from './GoToSignUp';

export default function ProcessVerification(props) {
    const [code, setCode] = React.useState([]);
    const [confirmingCode, setConfirmingCode] = React.useState(false);

    const isNumber = (value) => {
        let validNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
        for(let i = 0; i < value.length; i++) {
            if(!validNumbers.includes(value[i])) {
            return false;
            }
        }
        return true;
    }

    const [currentInputIndex, setCurrentInputIndex] = useState(0);
    let setNextCodeInput = (e) => {
        let fullCode = code;
        let index = Number((e.target.id).split('-')[1]);
        if(index !== currentInputIndex) {return}
        if(e.keyCode === 8) {
            if(index > 0) {
                let newIndex = Number(currentInputIndex) - 1;
                document.getElementById(`codeInput-${newIndex}`).focus()
                document.getElementById(`codeInput-${newIndex}`).value = '';
                setCurrentInputIndex(newIndex);
            }
            fullCode.pop();
            setCode(fullCode);
            return
        } else {
            if(code.length > 5 || !isNumber(e.target.value)) {return}
            fullCode.push(e.target.value);
            if(fullCode.length === 6) {
                confirmCode();
            }
            let newIndex = Number(index) + 1
            setCode(fullCode);
            if(index > 4) {return}
            document.getElementById(`codeInput-${newIndex}`).focus()
            setCurrentInputIndex(newIndex)
        }
    }

    let resetAll = () => {
        setCurrentInputIndex(0);
        setConfirmingCode(false);
        setCode([])
    }

    const [error, setError] = useState(false);
    const [userHasToSignUp, setUserHasToSignUp] = useState(false);
    const confirmCode = () => {
        let tok =  btoa(`${props.unicycle}:${props.pencil}`);
        setConfirmingCode(true);
        let codeValue = code.join('');
        let data = JSON.stringify({
            "orgId": props.orgId,
            "typeEmailOrMobile": props.verificationType,
            "typeRsvpOrCheckIn": props.urlParams,
            "email": props.email,
            "mobile": props.mobile,
            "verificationCode": codeValue
        })

        axios.post('https://api.churchpad.com/v3/rsvp-check-in-web-process-verification-code/', data, {
            headers: { 
                'Authorization' : `Basic ${tok}`,
                'Content-Type': 'application/json',
            },
        }).then(res => {
            let data = res.data;
            if(res.data.responseMessage !== 'success') {
                setError(res.data.responseMessage);
                setConfirmingCode(false);
            } else {
                if(data.responseData.nextAction === 'check-in') {
                    window.location = `https://checkin.churchpad.com/?cp=${res.data.responseData.cp}`;
                } else if(data.responseData.nextAction === 'rsvp') {
                    window.location = `https://rsvp.churchpad.com/?cp=${res.data.responseData.cp}`;
                } else {
                    setUserHasToSignUp(true);
                }
            }
            resetAll();
        }).catch(err => {
            setError('Enter the code again');
            setConfirmingCode(false)
            resetAll();
            console.log(err);
        })
    }
    let codeInput = [];
    for(let i = 0; i < 6; i++) {
        codeInput.push(i);
    }

    // console.log(code)

    return (
        <>
            {userHasToSignUp ? <GoToSignUp
                colors={{...props.colors}}
                orgId={props.orgId}
                pencil={props.pencil}
                unicycle={props.unicycle}
                type={props.urlParams}
            /> : 
            <>
                <div className="icon-container" style={{backgroundColor:`${props.colors.background}f1`}}>
                    <div className="verification-header">
                        <span className="icon" style={{boxShadow: `0px 3px 3px ${props.colors.background}b3`}}>
                            <i className={`las la-paper-plane`} style={{color: `${props.colors.background}f1`}}></i>
                        </span>
                        <div className="sub-header">
                            <h3>Enter the 6-digit verification code we sent to you. {props.verificationType === 'email' ? 'Check your spam folder' : ''}. Expires in 15 minutes.</h3>
                        </div>
                    </div> 
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,64L40,58.7C80,53,160,43,240,64C320,85,400,139,480,170.7C560,203,640,213,720,202.7C800,192,880,160,960,170.7C1040,181,1120,235,1200,224C1280,213,1360,139,1400,101.3L1440,64L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path></svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,128L24,112C48,96,96,64,144,64C192,64,240,96,288,101.3C336,107,384,85,432,106.7C480,128,528,192,576,192C624,192,672,128,720,117.3C768,107,816,149,864,160C912,171,960,149,1008,128C1056,107,1104,85,1152,85.3C1200,85,1248,107,1296,106.7C1344,107,1392,85,1416,74.7L1440,64L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"></path></svg>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,64L80,90.7C160,117,320,171,480,186.7C640,203,800,181,960,149.3C1120,117,1280,75,1360,53.3L1440,32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,288L80,288C160,288,320,288,480,256C640,224,800,160,960,133.3C1120,107,1280,117,1360,122.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill={`${props.colors.background}f1`} fillOpacity="1" d="M0,32L1440,320L1440,0L0,0Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,32L1440,320L1440,320L0,320Z"></path></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#fff" fillOpacity="1" d="M0,160L60,138.7C120,117,240,75,360,74.7C480,75,600,117,720,149.3C840,181,960,203,1080,186.7C1200,171,1320,117,1380,90.7L1440,64L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg> */}
                </div>
                <div className="form-container process-verification">
                    {!confirmingCode ? <form className="col s12">
                        <div className="inputs">
                            {error ? <h4 className="red-text">{error}</h4> : null}
                            {
                                codeInput.map((item, index) => {
                                    return (
                                        <input type="text" key={index} id={`codeInput-${index}`} className={`center value ${currentInputIndex === index ? '' : ' disabled'}`} maxLength='1' 
                                        // disabled={currentInputIndex === index ? false : true}
                                        // autoFocus={currentInputIndex === index ? true : false}
                                        onKeyUp={setNextCodeInput}
                                        // value={code[index]}
                                        />
                                    )
                                })
                            }
                        </div>
                    </form> : 
                            <>
                                <h4>Verifying code</h4>
                                <Spinner/>
                            </>
                    }
                </div> 
            </>
            }
        </>
    )
}
